export default class GMap {
  static exec() {
    const els = document.querySelectorAll('[data-component="gmap"]');
        els.forEach(function (el) {
            new GMap(el);
        });
  }

  constructor(el) {
    this.el = el;
    this.mapEl = this.el.querySelector('[data-el="map"]');
    this.lat = parseFloat(this.el.getAttribute('data-lat'));
    this.lng = parseFloat(this.el.getAttribute('data-lng'));

    this.map();
  }

  async map() {
    const position = { lat: this.lat, lng: this.lng };
    const { Map } = await google.maps.importLibrary("maps");
    const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

    const map = new Map(this.mapEl, {
      zoom: 17,
      center: position,
      mapId: "gmap"
    });
    const marker = new AdvancedMarkerElement({
      map: map,
      position: position
    });
  }
}
